/* ── Edit Template modal (groups-only) ─────────────────────────────── */
.editModal {
  width: 420px;
  max-width: 100%;
}

.editModalBody {
  padding: 0;
}

.editModalContent {
  padding: 16px 24px 8px;

  p {
    text-align: left !important;
  }
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.purposeOptions {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.purposeOption {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;

  // cancel FormFieldV2's default bottom margin
  > :first-child {
    margin-bottom: 0 !important;
  }
}

/* ── Preview Template modal ─────────────────────────────────────────── */
.previewModal {
  width: 340px;
  max-width: 100%;
}

.previewModalBody {
  padding: 0;
}

.languageTabs {
  display: flex;
  gap: 6px;
  padding: 12px 16px 0;
  flex-wrap: wrap;
}

.languageTab {
  background: transparent;
  border: 1px solid #444;
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  color: #ccc;
  cursor: pointer;

  &:hover {
    border-color: #888;
    color: #fff;
  }
}

.languageTabActive {
  background: #444;
  border-color: #666;
  color: #fff;
}

.previewModalContent {
  display: flex;
  justify-content: center;
  padding: 16px 24px 24px;
}

/* ── Shared phone frame ─────────────────────────────────────────────── */
.phoneFrame {
  width: 260px;
  border: 2px solid #ddd;
  border-radius: 24px;
  overflow: hidden;
  background: #e5ddd5;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.phoneHeader {
  background: #075e54;
  color: #fff;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.phoneAvatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #128c7e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}

.chatArea {
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.chatBubble {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  word-wrap: break-word;
}

.bubbleContent {
  padding: 8px 10px;
}

.bubbleHeader {
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 4px;
  color: #333;
}

.bubbleBody {
  font-size: 12px;
  color: #333;
  white-space: pre-wrap;
  line-height: 1.4;
}

.bubbleFooter {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
}

.bubbleTime {
  font-size: 10px;
  color: #999;
  margin-top: 4px;
  text-align: right;
}

.previewButtons {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
}

.previewButton {
  background: #fff;
  border-radius: 6px;
  padding: 5px 10px;
  text-align: center;
  font-size: 11px;
  color: #00a5f4;
  font-weight: 500;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
